<template>
  <div
    @touchstart="onTouchstart"
    :class="['ai_box', (this.$root.$data.miniprogram || this.$root.$data.isApp) ? 'ai_box_top' : '']"
  >
    <common-title :titleName="titleName" :isAPPShow="false" :bcColor="'#f7f8fc'"></common-title>
    <div class="watermark"></div>
    <div class="lists_area" ref="van_scroll_ref">
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" ref="van_scroll_ref"> -->
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="20"
        @load="onLoad"
        direction="up"
      >
        <!-- direction="up" -->
        <!-- 历史消息 -->
        <!--    到顶提示    -->
        <div v-if="finished && total !== 0" class="more_history_item">没有更多记录了！</div>
        <div id="AILISTITEM" class="history_item" v-for="(item, index) in historyList" :key="index">
          <div v-if="toolRawTime(item.createTime) && item.roleType === 1" class="msg_time_box">
            <div class="msg_time">{{ toolRawTime(item.createTime) }}</div>
          </div>
          <div class="my_msg_box" v-if="item.roleType === 1">
            <div
              class="my_msg my_msg_history"
              :style="{ background: appInfo.msgBgColor ? appInfo.msgBgColor : '#ff7f41', color: appInfo.msgFontColor ? appInfo.msgFontColor : '#fff' }"
            >
              <div ref="answerContent" class="msg_text" v-html="item.content"></div>
            </div>
          </div>
          <div class="ai_msg_img" v-if="item.roleType === 2">
            <img
              :src="appInfo.appAvatar || 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_title_img.png'"
              alt
            />
            <div class="ai_msg_img_name">{{ appInfo.appNickname || '启小航' }}</div>
          </div>
          <div class="ai_msg" v-if="item.roleType === 2">
            <div class="msg_text" v-html="item.content" @click="handleEvent"></div>
            <AgreeFooter
              @agreeCallBack="agreeCallBack"
              :footerInfo="item?.footerInfo"
              v-show="item?.footerInfo?.show === 1 && aiCode !== 'ytzzzs001'"
            ></AgreeFooter>
          </div>
        </div>
        <!-- 欢迎语位置 -->
        <div id="ai_wecome_click" class="wecome_item" v-if="showWecome">
          <div
            class="wecome_back"
            :style="{ background: `url(${appInfo.welcomeBgImage ? appInfo.welcomeBgImage : 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_card.png'})` }"
          >
            <div class="tool_hello">{{ toolHello }}</div>
            <div class="tool_desc">{{ toolDesc }}</div>
            <!-- <img
              class="img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_card.png"
              alt
            />-->
          </div>
          <div class="wecome_card">
            <div class="wecome_tip">
              <img
                class="img_wenhao"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/wenhao.png"
                alt
              />
              <div class="tip_wen">你可以试着问我：</div>

              <div class="tip_qiehuan" @click="onSwapHello">换一批</div>

              <img
                class="img_qiehuan"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/qiehuan.png"
                alt
                @click="onSwapHello"
              />
            </div>
            <div class="wecome_lists" v-for="(item, index) in currentWecomeList" :key="item">
              <div :class="['wecome_list', index !== 0 ? 'wecome_list_line' : '']">
                <div class="wecome_list_text">{{ item }}</div>
                <div class="wecome_btn" @click="onMySend(item)">问一下</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新消息列表 -->
        <div id="AILISTITEM" class="history_item" v-for="item in newList" :key="item">
          <div class="my_msg_box">
            <div
              class="my_msg"
              :style="{ background: appInfo.msgBgColor ? appInfo.msgBgColor : '#ff7f41', color: appInfo.msgFontColor ? appInfo.msgFontColor : '#fff' }"
            >
              <div class="msg_text" v-html="item.question"></div>
            </div>
          </div>
          <div class="ai_msg_img">
            <img
              :src="appInfo.appAvatar || 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_title_img.png'"
              alt
            />
            <div class="ai_msg_img_name">{{ appInfo.appNickname || '启小航' }}</div>
          </div>
          <div class="ai_msg">
            <div class="msg_text" v-html="item.answer" @click="handleEvent"></div>
            <div class="stop_tip_line" v-if="item.type === 2"></div>
            <div class="stop_tip_text" v-if="item.type === 2">已停止回答</div>
            <AgreeFooter
              @agreeCallBack="agreeCallBack"
              :footerInfo="item?.footerInfo"
              v-show="item?.footerInfo?.show === 1"
            ></AgreeFooter>
          </div>
        </div>

        <!-- 最新一条消息的临时展示位置 -->
        <div class="history_item" v-if="ls_my_msg || ls_ai_msg || markdownValue">
          <div class="my_msg_box">
            <div
              class="my_msg"
              v-if="ls_my_msg"
              :style="{ background: appInfo.msgBgColor ? appInfo.msgBgColor : '#ff7f41', color: appInfo.msgFontColor ? appInfo.msgFontColor : '#fff' }"
            >
              <div class="msg_text" v-html="ls_my_msg"></div>
            </div>
          </div>
          <div class="ai_msg_img" v-if="ls_ai_msg">
            <img
              :src="appInfo.appAvatar || 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_title_img.png'"
              alt
            />
            <div class="ai_msg_img_name">{{ appInfo.appNickname || '启小航' }}</div>
          </div>
          <div class="ai_msg" v-if="markdownValue || ls_ai_msg">
            <div
              class="msg_text newmsg_text"
              v-html="renderLoadingIcon(markdownValue || ls_ai_msg)"
            ></div>
          </div>
        </div>
        <div class="msg_ai_tip" v-if="historyList.length !== 0 || newList.length !== 0">内容由AI生成</div>
        <div v-if="fileList.length" class="enpty_list"></div>
        <div :class="['empty_box', aiCode === 'qhkyzs001' ? 'empty_box_qh' : '']"></div>
      </van-list>
      <!--      <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />-->
      <!-- <Foot /> -->
      <!-- </van-pull-refresh> -->
    </div>
    <div
      :class="['bottom', inputRender > 0 ? 'bottom_absolate' : '', aiCode === 'qhkyzs001' ? 'bottom_qh' : '', fileList.length ? 'whiteBg' : '']"
      id="ai_aisistant_bottom"
      key="deufwrgbkajwhefiu"
      @touchstart.stop="onTouchstartStop"
    >
      <div class="link_btn_box" v-if="aiCode === 'qhkyzs001'">
        <div class="link_btn" @click="goLinkTool(4)">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_link_dayi.png" alt />
          AI答疑
        </div>
        <div class="link_btn" @click="goLinkTool(1)">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_link_zexiao.png" alt />
          AI择校
        </div>
        <div class="link_btn" @click="goLinkTool(2)">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_link_pigai.png" alt />
          AI作文批改
        </div>
        <div class="link_btn" @click="goLinkTool(3)">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_link_danci.png" alt />
          背单词
        </div>
      </div>
      <div class="input">
        <!-- <input
          class="userNewPsd"
          @input="onInput"
          v-model.trim="inputMsg"
          clearable
          placeholder="在这里向我提问哦~"
          @click="onFocus"
          type="text"
          @keyboardheightchange="onBoardChange"
        />-->
        <van-form>
          <div :class="{ upload_img: true, active: fileList.length }" v-if="aiCode === 'ytzzzs001'">
            <UploadImg @getListFile="getListFile" :fileList="fileList" />
          </div>
          <van-field
            id="aiassistantinput"
            key="jsdfkgsiukejfhiurweh"
            :class="{ vanField: true, uploadLeft: aiCode === 'ytzzzs001' }"
            @input="onInput"
            v-model.trim="inputMsg"
            clearable
            placeholder="在这里向我提问哦~"
            @focus="onInputFourse"
            @blur="onBulr"
            type="text"
            :disabled="sendStatus === '3'"
            @change="onChange"
            @click.stop="onClick"
          />
        </van-form>
      </div>
      <div class="send_btn">
        <img
          class="img"
          v-if="sendStatus === '1'"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_no_send.png"
          alt
        />
        <img
          class="img"
          v-if="sendStatus === '2'"
          :src="appInfo.sendBtnImage || 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_send.png'"
          alt
          @click="onMySend(inputMsg, true)"
        />
        <img
          class="img"
          v-if="sendStatus === '3'"
          :src="appInfo.stopBtnImage || 'https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_send_ing.png'"
          alt
          @click="onStopSend"
        />
      </div>
    </div>
    <div class="ai_dis_none">
      <input type="text" ref="inputRef" />
    </div>
  </div>
</template>

<script>
import EmptyData from '@/components/emptyData/emptyData.vue';
import AgreeFooter from '@/pages/aiAssistant/components/AgreeFooter/index.vue';
import UploadImg from './components/UploadImg/index.vue';
// eslint-disable-next-line import/no-cycle
import { reqCourseDetail } from '@/api/courseDetail/index';
// import Foot from '@/components/foot/privacy.vue';
// eslint-disable-next-line import/no-cycle
import {
  openAiConnect,
  stopAiConnect,
  getAiBotList,
  getAiInfo,
  getAiSessionId,
  getHistoryAiInfo,
  getAiBotAppoint,
} from '@/api/aiAssistant/index';
import moment from 'moment';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { isMatch } from 'lodash';

import { reqSchemeUrl } from '@/api/openMini';
import { setBaseUrl } from '@/utils/tools';
import markdownIt from 'markdown-it';
import { ImagePreview } from 'vant';

const md = new markdownIt({});

let canKeyBoard = false;
let canKeyBoardTime = false;

let lsTimer = null;

export default {
  components: {
    EmptyData,
    AgreeFooter,
    UploadImg,
    // Foot,
  },
  data() {
    return {
      historyList: [],
      newList: [], // 新回话数组
      // 优化性能，临时存储当前问题和当前回答。完成后塞入新回话数组
      ls_my_msg: '',
      ls_ai_msg: '',
      // 加载相关
      refreshing: false,
      loading: false,
      finished: false,
      // 输入框数据
      inputMsg: '',
      sendStatus: '1', // 1、不可发送  2、可发送  3、生成中
      toolDesc: '',
      toolHello: '',
      currentWecomeList: [],
      allWecomeList: [],

      showWecome: false,

      currentTime: '',

      pageNum: 1,
      pageSize: 10,

      textCallStr: '',
      textCallStrCache: '',
      textCallAi: false,

      // 当前应用id
      currAiBotID: null,
      // 当前会话id
      currSessionId: null,
      // 当前连接id
      currConnectId: null,
      stopCall: false,
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      aiCode: '',
      markdownValue: '',
      fileList: [], // 图片列表
      fileListOfApi: [], // 用于临时保存接口需要的入参数
      appInfo: {},
      total: 0, // 历史消息总数
      noScroll: true,
      inputRender: -1,

      inputTimer: null,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    inputMsg(val) {
      console.log('inputMsg', val);

      this.noScroll = true;

      if (this.inputTimer) {
        clearTimeout(this.inputTimer);
      }
      this.inputTimer = setTimeout(() => {
        this.noScroll = false;
      }, 100);
    },
  },

  mounted() {
    // if (!this.userInfo?.id) {
    //   const param = { redirect: '/aiAssistant', ...this.$route.query };
    //   this.$router.push({ path: '/registrationLogin', query: param });
    //   return;
    // }
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);

    window.addEventListener('scroll', this.scrollChange);
    this.$root.getUserInfo().then(() => {
      if (this.userInfo.id) {
        const { aiCode } = this.$route.query;
        window.scroll(0, 999999999999);
        if (!window.localStorage.getItem('AI_ASSISTANT_WECOME')) {
          this.showWecome = true;
          this.toolScrollUnder();
        }
        window.localStorage.setItem('AI_ASSISTANT_WECOME', 'true');

        this.loading = true;
        this.aiCode = aiCode;

        let currentEnv = '';
        ['pre.iqihang', 'release.iqihang', 'test.iqihang', 'dev.iqihang', 'localhost'].forEach(
          item => {
            if (window.location.href.indexOf(item) !== -1) {
              currentEnv = item.split('.')?.shift();
            }
          },
        );

        const sseUrlMap = {
          localhost: 'https://sse-test.iqihang.com/v1/ai-sse/connect',
          dev: 'https://sse-dev.iqihang.com/v1/ai-sse/connect',
          test: 'https://sse-test.iqihang.com/v1/ai-sse/connect',
          pre: 'https://sse-pre.iqihang.com/v1/ai-sse/connect',
        };
        this.sseUrl = sseUrlMap[currentEnv] || 'https://sse-prod.iqihang.com/v1/ai-sse/connect';

        getAiBotAppoint(aiCode).then(res => {
          const { data, currentTime } = res;
          this.currentTime = currentTime;
          const currAIBot = data;
          const { guideText, recommendPrompts, name, guideTitle, id } = currAIBot || {};
          document.title = name;
          this.titleName = name;
          this.appInfo = data;
          window.addEventListener('pageshow', () => {
            document.title = name || this?.titleName;
          });

          document.addEventListener(
            'visibilitychange',
            () => {
              document.title = name || this?.titleName;
              setTimeout(() => {
                document.title = name || this?.titleName;
              }, 300);
              setTimeout(() => {
                document.title = name || this?.titleName;
              }, 700);
              setTimeout(() => {
                document.title = name || this?.titleName;
              }, 1100);
            },
            false,
          );

          const recommendPromptsList = recommendPrompts ? JSON.parse(recommendPrompts) : [];
          this.toolDesc = guideText;
          this.toolHello = guideTitle;
          this.allWecomeList = recommendPromptsList;
          // this.currentWecomeList = recommendPromptsList.slice(0, 3); toolRandomWeCome
          this.currentWecomeList = this.toolRandomWeCome(recommendPromptsList);
          this.currAiBotID = id;
          getAiSessionId(id).then(res2 => {
            this.currSessionId = res2?.data;
            getHistoryAiInfo(res2?.data, this.pageNum, this.pageSize).then(res => {
              if (!res.data.data || res.data.data.length === 0) {
                this.finished = true;
              }
              this.total = res?.data?.total || 0;
              this.historyList = this.formatHistoryList(res.data?.data?.reverse() || []);
              this.handleClickImage();
              this.pageNum = 2;
              const afterItem = res.data?.data?.findLast(item => item.roleType === 1);
              if (!afterItem) {
                this.showWecome = true;
                this.toolScrollUnder();
                return;
              }
              // console.log(
              //   '时间差',
              //   res.currentTime,
              //   afterItem.createTime,
              //   moment(res.currentTime).diff(moment(afterItem.createTime), 'minutes'),
              // );
              if (moment(res.currentTime).diff(moment(afterItem.createTime), 'minutes') > 60) {
                this.showWecome = true;
              }
              this.toolScrollUnder();
              this.loading = false;
            });
          });
        });
      } else {
        this.toLogin();
      }
    });
    this.handleWrap();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollChange);
    const elements = document.getElementsByClassName('fileListImage');
    const array = Array.from(elements);
    array.forEach(el => {
      const imgList = el.querySelectorAll('img');
      imgList.forEach(el2 => {
        el2.removeEventListener('click', this.handleClick);
      });
    });
  },
  methods: {
    onBulr() {
      this.inputRender = -1;
      setTimeout(() => {
        this.noScroll = true;
      }, 10);
    },

    onInputFourse() {},

    onTouchstart() {
      console.log('touchstart---------------------------------------');
      if (this.inputRender > 0) {
        this.noScroll = false;
      }
    },

    onTouchstartStop() {
      console.log('onTouchstartStop---------------------------------------');
    },

    onClick() {
      console.log('click---------------------------------------');
      this.inputRender = -1;
      this.noScroll = true;
      setTimeout(() => {
        window.scrollTo(0, 999999999);
        setTimeout(() => {
          this.inputRender = 9999;
        }, 100);
      }, 300);
    },

    onInput() {
      if (this.inputMsg) {
        if (this.sendStatus === '1') {
          this.sendStatus = '2';
        }
      } else if (this.sendStatus === '2') {
        this.sendStatus = '1';
      }
    },

    onChange(e) {},

    scrollChange(e) {
      console.log('scrollChange', e);
      setTimeout(() => {
        if (this.noScroll) {
          return;
        }

        console.log('scrollChange---------------------------------------');

        this.noScroll = true;
        document.getElementById('aiassistantinput')?.blur?.();
      }, 10);
    },

    // 处理加载中的状态图片
    renderLoadingIcon(data) {
      return `${data} <img class="msg_text_loading_box" src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_loading.gif" alt=""/>`;
    },
    // 图片上传
    getListFile(data) {
      const list = data?.filter(item => item.status === 'done');
      if (list?.length) {
        setTimeout(() => {
          window.scrollTo({
            top: 999999999,
            behavior: 'smooth',
          });
        }, 100);
      }
      this.fileList = list;
      this.fileListOfApi = list;
    },
    // 处理换行
    handleWrap() {
      // setTimeout(() => {
      //   const domList = document.getElementsByClassName('wecome_list_text');
      //   for (let i = 0; i < domList.length; i++) {
      //     if (domList[i]?.scrollHeight > domList[i]?.offsetHeight) {
      //       domList[i]?.classList.add('wraps');
      //     }
      //   }
      // }, 2000);
    },
    // 处理富文本事件委托
    handleEvent(event) {
      // 跳转产品详情页
      if (event.target.dataset?.href) {
        const href = event.target.dataset?.href;
        if (this.miniprogram) {
          let url = href;
          const [domain, searchParams] = url.split('?');
          if (searchParams) {
            const params = searchParams.split('&');
            const paramsMap = new Map();
            params.forEach(item => {
              const [key, value] = item.split('=');
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value] of entries) {
              if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
            wx.miniProgram.navigateTo({
              url: `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
            });
          }
        } else if (this.$root.$data.isApp) {
          const courseId = href.match(/courseId=(\d+)/)[1];
          this.$sendToApp(
            'goCourseDetailParams',
            {
              courseId,
              params: '&source=aiCourse',
            },
            false,
          );
        } else {
          window.open(href, '_blank');
        }
      }
    },

    async getLoginAfter() {
      window.location.reload();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    toLogin() {
      // if (this.isApp) {
      //   const address = `${window.location.origin}/ark/collectCardIndex?cardActivityId=${this.activityId}`;
      //   this.$sendToApp('newLogin', { clientType: 30, address }, true);
      // } else
      const { aiCode } = this.$route.query;
      if (this.miniprogram) {
        const redirctWebView = {
          zzzswd001: 'assistantPolicits',
          qhkyzs001: 'assistantQuestion',
          ytzzzs001: 'aiAssistant',
        };
        const redirctUrl = encodeURIComponent(
          `/subPackages/${redirctWebView[aiCode]}/index?url=${encodeURIComponent('ai')}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else if (this.isApp) {
        const redirctWebLink = {
          zzzswd001: '/aiAssistantZz',
          qhkyzs001: '/aiAssistantTk',
          ytzzzs001: '/aiAssistantYtZz',
        };
        const address = `${window.location.origin}/ark/${redirctWebLink[aiCode]}`;
        this.$sendToApp('newLogin', { clientType: 17, address }, true);
      } else {
        const redirctWebLink = {
          zzzswd001: '/aiAssistantZz',
          qhkyzs001: '/aiAssistantTk',
          ytzzzs001: '/aiAssistantYtZz',
        };
        const param = { redirect: redirctWebLink[aiCode], ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
      }
    },
    onBoardChange(e) {
      console.log('键盘高度', e);
    },
    onLoad() {
      this.loading = true;
      if (!this.finished) {
        getHistoryAiInfo(this.currSessionId, this.pageNum, this.pageSize).then(res => {
          const list = this.formatHistoryList(res.data?.data?.reverse() || []);
          if (list.length > 0) {
            this.pageNum += 1;
            this.historyList = [...list, ...this.historyList];
            this.handleClickImage();
            this.$nextTick(() => {
              const currTop = document.getElementsByClassName('history_item')[list.length]
                .offsetTop;
              window.scroll(0, currTop);
              this.loading = false;
            });
          } else {
            this.loading = false;
            this.finished = true;
          }
        });
      }

      // setTimeout(() => {
      //   const length = 4;
      //   const currTop = document.getElementsByClassName('history_item')[length - 1].offsetTop;
      //   const pushList = [Math.random(), Math.random(), Math.random(), Math.random()];
      //   console.log(pushList);
      //   this.historyList = [...pushList, ...this.historyList];
      //   this.$nextTick(() => {
      //     window.scroll(0, currTop);
      //     this.loading = false;
      //   });
      // }, 1000);
    },
    onRefresh() {
      console.log('触发刷新');
    },
    // 判断dom是否有事件监听
    hasEventListener(element, eventType) {
      return (
        element.eventListener &&
        element.eventListener[eventType] &&
        element.eventListener[eventType].length > 0
      );
    },
    // 给图片添加点击事件
    handleClickImage() {
      const that = this;
      this.$nextTick(() => {
        const elements = document.getElementsByClassName('fileListImage');
        const array = Array.from(elements);
        array.forEach(el => {
          const imgList = el.querySelectorAll('img');
          imgList.forEach(el2 => {
            if (!that.hasEventListener(el2, 'click')) {
              el2.addEventListener('click', that.handleClick);
            }
          });
        });
      });
    },
    // 点击图片预览
    handleClick(e) {
      if (e.target.className === 'fileListImage_img' && e.target.currentSrc) {
        ImagePreview([e.target.currentSrc]);
      }
    },
    // 处理发送的消息存在图片
    handleSendMsgImg(msg, fileList) {
      const list = fileList?.map(item => item?.url);
      const dom = list.map(item => `<img class="fileListImage_img" src='${item}' />`).join('');
      return dom ? `${msg} <div class="fileListImage">${dom}</div>` : msg;
    },
    onMySend(msg, isInput) {
      if (this.sendStatus === '3') {
        return;
      }
      this.ls_my_msg = this.handleSendMsgImg(msg, this.fileList);
      this.ls_ai_msg = `${
        this.appInfo.appNickname ? this.appInfo.appNickname : '启小航'
      }正在思考中`;
      this.textCallAi = true;
      this.fileList = []; // 清空上一次的图片
      if (isInput) {
        this.inputMsg = '';
      }
      this.sendStatus = '3';
      this.toolScrollUnder();
      // 执行获取接口
      this.eventReq(msg);
      // setTimeout(() => {
      //   this.ls_ai_msg = '';
      //   this.textCallStr = `${this.textCallStr}你猜猜我今晚吃什么你猜猜我今晚吃什么你猜猜我今晚吃什么`;
      //   this.toolScrollUnder();
      //   setTimeout(() => {
      //     console.log('1', this.textCallStr, this.textCallAi);
      //     // this.ls_ai_msg = `${this.ls_ai_msg}吃好吃的`;
      //     if (this.textCallAi) {
      //       this.textCallStr = `${this.textCallStr}吃好吃的`;
      //       this.textCallAi = false;
      //       this.toolScrollUnder();
      //     }
      //   }, 1000);
      // }, 1000);
    },
    onStopSend() {
      if (this.currConnectId) {
        this.sendStatus = '1';
        this.textCallStr = '';
        this.textCallStrCache = '';
        this.textCallAi = false;
        if (!this.textCallStr && !this.textCallStrCache) {
          this.$nextTick(() => {
            this.onPushNew(2);
          });
        }
        this.stopCall.abort();
        stopAiConnect(this.currConnectId).then(() => {});
      }
    },

    // sse请求
    eventReq(ques) {
      // const eventSource = new EventSource(
      //   `https://mobile-dev.iqihang.com/api/ark/tool/v1/ai-sse/connect?appId=${1}&content=haha&sessionId=2`,
      //   {
      //     withCredentials: true,
      //   },
      // );
      // eventSource.onmessage(msg => {
      //   console.log('响应', msg);
      // });
      const that = this;
      const token = window.localStorage.getItem('accessToken');
      const stop = new AbortController();
      this.stopCall = stop;
      fetchEventSource(this.sseUrl, {
        method: 'POST',
        body: JSON.stringify({
          appId: this.currAiBotID,
          content: ques,
          sessionId: this.currSessionId,
          imageList: this.fileListOfApi?.map(item => item?.url),
        }),
        signal: stop.signal,
        openWhenHidden: true,
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          // accept: '*/*',
        },
        onopen() {
          that.ls_ai_msg = '';
          return Promise.resolve();
        },
        onmessage(msg) {
          const { data } = msg;
          const { connectId, content, type } = JSON.parse(data);
          that.currConnectId = connectId;
          that.fileListOfApi = [];
          if (that.textCallAi && (type === 2000 || type === 2001)) {
            if (that.textCallStr) {
              that.textCallStrCache = `${that.textCallStrCache}${that.toolFilterSymbol(content)}`;
            } else {
              that.textCallStr = that.toolFilterSymbol(content);
              that.$nextTick(() => {
                that.toolRowTextDy.call(that);
              });
            }
            that.toolScrollUnder();
          }
          // 结束
          if (type === 2001) {
            that.textCallAi = false;
            // if (!that.textCallStr && !that.textCallStrCache) {
            //   that.$nextTick(() => {
            //     that.toolRowTextDy.call(that);
            //   });
            // }
          }
        },
        onclose() {
          that.textCallAi = false;
          that.$nextTick(() => {
            if (!that.textCallStr && !that.textCallStrCache) {
              that.$nextTick(() => {
                that.toolRowTextDy.call(that);
              });
            }
          });
        },
        onerror(e) {
          console.log('链接失败+++++++', e);
          this.$toast('操作过于频繁，请稍后再试');
          return Promise.resolve();
          // that.stopCall.abort();
          // stopAiConnect(this.currConnectId).then(() => {});
        },
      });
    },

    onSwapHello() {
      // const allListLength = this.allWecomeList.length;
      // const currEnd = this.currentWecomeList[this.currentWecomeList.length - 1];
      // const currIndex = this.allWecomeList.indexOf(currEnd);

      // const newList = [];

      // if (currIndex !== -1) {
      //   for (let i = 1; i < 4; i += 1) {
      //     if (this.allWecomeList[(currIndex + i) % allListLength]) {
      //       newList.push(this.allWecomeList[(currIndex + i) % allListLength]);
      //     }
      //   }
      // }
      this.currentWecomeList = this.toolRandomWeCome(this.allWecomeList);
      this.handleWrap();
    },

    // 将临时消息推入新消息队列
    onPushNew(type = 1) {
      if (this.ls_ai_msg && this.ls_my_msg) {
        const optNewList = [...this.newList];
        const data = {
          connectId: this.currConnectId,
          type,
          question: this.ls_my_msg,
          answer: this.ls_ai_msg,
        };

        if (this.checkLastSentence(this.ls_ai_msg)) {
          data.footerInfo = {
            show: 1,
            isAgree: 0,
            connectId: this.currConnectId,
          };
        }
        const wrapLinkInfo = this.wrapLinkWithATag(this.ls_ai_msg);
        if (wrapLinkInfo.isMatched) {
          data.answer = wrapLinkInfo.newText;
        }
        optNewList.push(data);
        this.ls_my_msg = '';
        this.ls_ai_msg = '';
        this.markdownValue = '';
        if (this.inputMsg) {
          this.sendStatus = '2';
        } else {
          this.sendStatus = '1';
        }
        this.newList = optNewList;
        this.handleClickImage();
        this.toolScrollUnder();
        if (wrapLinkInfo.isMatched) {
          this.wrapLinkWithCourseBlock(wrapLinkInfo.originText, this.currConnectId);
        }
      }
    },

    toolScrollUnder() {
      this.$nextTick(() => {
        window.scroll(0, 99999999999999);
        setTimeout(() => {
          window.scroll(0, 99999999999999);
        }, 50);
      });
    },

    toolRawTime(msgTime, currTime = this.currentTime) {
      if (!msgTime) {
        return '';
      }

      const minutesDiff = moment(currTime).diff(moment(msgTime), 'minutes'); // 分钟差

      const minutesZuo = moment()
        .subtract(1, 'day')
        .format('YYYY-MM-DD'); // 昨天

      const isOneDay = msgTime.slice(0, 10) === currTime.slice(0, 10); // 是否同一天

      const isOneYear = msgTime.slice(0, 4) === currTime.slice(0, 4); // 是否同一年

      // const diff = moment(currTime).format('x') - moment(msgTime).format('x');
      // const time = moment.duration(diff);
      // const days = time.days(); // 天数差
      // console.log('天数差', days);

      if (!isOneYear) {
        return moment(msgTime).format('YYYY年MM月DD日 HH:mm');
      }

      if (minutesZuo === msgTime.slice(0, 10)) {
        return `昨天 ${msgTime.slice(11, -3)}`;
      }

      if (!isOneDay) {
        return moment(msgTime).format('MM月DD日 HH:mm');
      }
      if (minutesDiff > 60) {
        return msgTime.slice(11, -3);
      }
      return '';
    },

    /**
     * 将 Markdown 文本中的表格转换为 HTML 表格
     * @param {string} markdownText - 包含 Markdown 表格的文本
     * @return {string} 转换后的 HTML 文本
     */
    convertMarkdownTablesToHtml(value) {
      const markdownText = String(value);
      // 分割文本为行数组
      const lines = markdownText.split('\n');
      let inTable = false;
      let tableLines = [];
      let result = '';

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        // 检测表格开始
        if (this.isTableLine(line)) {
          if (!inTable) {
            inTable = true;
            tableLines = [];
          }
          tableLines.push(line);
        }
        // 表格结束
        else {
          if (inTable) {
            // 处理收集到的表格行
            result += this.convertTableToHtml(tableLines);
            inTable = false;
          }
          result += line + '\n';
        }
      }
      // 处理文本末尾的表格
      if (inTable) {
        result += this.convertTableToHtml(tableLines);
      }

      return result;
    },

    /**
     * 判断一行是否是 Markdown 表格的一部分
     * @param {string} line - 要检查的行
     * @return {boolean} 是否是表格行
     */
    isTableLine(line) {
      // 表格行必须包含 | 并且至少有两个 |
      return line.includes('|') && (line.match(/\|/g) || []).length >= 2;
    },

    /**
     * 将 Markdown 表格行转换为 HTML 表格
     * @param {string[]} tableLines - 表格行数组
     * @return {string} HTML 表格字符串
     */
    convertTableToHtml(tableLines) {
      if (tableLines.length < 2) return '';

      // 提取表头
      const headers = tableLines[0]
        .split('|')
        .map(header => header.trim())
        .filter(header => header !== '');

      // 提取数据行（从第三行开始）
      const dataRows = [];
      for (let i = 2; i < tableLines.length; i++) {
        const cells = tableLines[i]
          .split('|')
          .map(cell => cell.trim())
          .filter(cell => cell !== '');

        if (cells.length === headers.length) {
          dataRows.push(cells);
        }
      }

      // 构建 HTML 表格
      const bg = `background: linear-gradient( 270deg,${
        this.appInfo.tableHeaderColor ? this.appInfo.tableHeaderColor.split(',')[0] : '#f60'
      } 0%,${
        this.appInfo.tableHeaderColor ? this.appInfo.tableHeaderColor.split(',')[1] : '#ff8a00'
      } 100%);`;
      let html = '<div class="table_box">\n<table>\n<thead>\n<tr style="' + bg + '">\n';

      // 添加表头
      headers.forEach(header => {
        html += `    <th>${header}</th>\n`;
      });
      html += '</tr>\n</thead>\n<tbody>\n';

      // 添加数据行
      dataRows.forEach(row => {
        html += '<tr>\n';
        row.forEach(cell => {
          html += `    <td>${cell}</td>\n`;
        });
        html += '</tr>\n';
      });

      html += '</tbody>\n</table>\n</div>\n';
      return html;
    },

    toolRowTextDy() {
      if (this.textCallStr) {
        this.ls_ai_msg = `${this.ls_ai_msg}${this.textCallStr[0]}`;
        // 表格格式输出几本马克思书籍
        if (this.isTableLine(this.ls_ai_msg)) {
          this.markdownValue = this.convertMarkdownTablesToHtml(this.ls_ai_msg);
        }
        this.toolScrollUnder();
        let lsText = this.textCallStr.slice(1);
        if (!lsText) {
          lsText = this.textCallStrCache;
          this.textCallStrCache = '';
        }
        this.textCallStr = lsText;
        lsTimer = setTimeout(() => {
          clearTimeout(lsTimer);
          lsTimer = null;
          this.toolRowTextDy();
        }, 10);
        // if (lsText) {
        //   setTimeout(() => {
        //     this.toolRowTextDy();
        //   }, 100);
        // } else if (!this.textCallAi) {
        //   this.$nextTick(() => {
        //     this.onPushNew(1);
        //   });
        // }
      } else if (!this.textCallAi) {
        this.$nextTick(() => {
          if (this.isTableLine(this.ls_ai_msg)) {
            this.ls_ai_msg = this.markdownValue;
          }
          this.onPushNew(1);
        });
      }
    },

    toolRandomWeCome(list) {
      const length = list?.length || 0;

      if (!list || length === 0) {
        return [];
      }
      if (length < 3) {
        return list;
      }

      const newList = [];
      const lsIdx = Math.min(Math.floor(Math.random() * length), length - 1);
      newList.push(list[lsIdx % length]);
      newList.push(list[(lsIdx + 1) % length]);
      newList.push(list[(lsIdx + 2) % length]);
      return newList;
    },

    toolFilterSymbol(str) {
      return str ? str.replace(/\*{2}/g, '').replace(/#{3}/g, '') : '';
    },
    // 判断最后一句话是否包含目标短语 是否需要老师 提供备考指导
    checkLastSentence(text) {
      const { aiCode } = this.$route.query;
      if (aiCode === 'zzzswd001' || aiCode === 'ytzzzs001') {
        return false;
      }
      const punctuation = ['。', '？', '！', '……'];

      let lastSentence = '';
      let foundPunctuation = false;
      for (let i = text.length - 1; i >= 0; i--) {
        if (punctuation.includes(text[i])) {
          if (foundPunctuation) {
            break;
          }
          foundPunctuation = true;
        }
        lastSentence = text[i] + lastSentence;
      }

      // 判断最后一句话是否包含目标短语
      if (lastSentence.includes('是否需要老师') && lastSentence.includes('提供备考指导')) {
        const index1 = lastSentence.indexOf('是否需要老师');
        const index2 = lastSentence.indexOf('提供备考指导');
        if (index1 < index2) {
          return true;
        }
      }

      return false;
    },
    // 点击是否同意的回调
    agreeCallBack(type) {
      if (type === 1) {
        this.ls_my_msg = '需要';
        this.textCallStr =
          '已为您安排一对一考研咨询老师，老师会在24小时内与您联系，请保持电话畅通~如果您有更多考研问题，可以继续向我提问。';
        this.$nextTick(() => {
          this.toolRowTextDy();
        });
      } else {
        this.ls_my_msg = '不需要';
        this.toolScrollUnder();
      }
    },
    // 替换课程链接为带 <a> 标签的版本
    wrapLinkWithATag(text) {
      const { aiCode } = this.$route.query;
      if (aiCode === 'zzzswd001' || aiCode === 'ytzzzs001') {
        return {
          isMatched: false,
        };
      }
      // 匹配固定格式的课程链接
      const pattern = /课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)`/;
      const match = text.match(pattern);
      if (match) {
        const fullLink = match[1];
        const pattern1 = /课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)\s*\n*/;
        const aTag = `<div style="color: #ff7f41; display: inline-block;" data-href="${fullLink}">点击查看课程</div>`;
        const newText = text.replace(pattern1, `课程链接：${aTag}`);
        return {
          isMatched: true,
          newText,
          originText: text,
        };
      }
      return {
        isMatched: false,
      };
    },
    // 替换课程链接为课程块 只在新发起的问题中替换
    wrapLinkWithCourseBlock(text, connectId) {
      // 匹配固定格式的课程链接
      const pattern = /课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)`/;
      const match = text.match(pattern);
      const fullLink = match[1]; // 提取完整的 https 链接
      const courseId = fullLink.match(/courseId=(\d+)/)[1];
      reqCourseDetail(courseId)
        .then(res => {
          const { data } = res;
          const { name, sellPrice, coverMobile, productAttributeRespVOS } = data;
          const time = productAttributeRespVOS.filter(
            item => item.extendAttributeNameEn === 'classPeriod',
          )[0].dataJson;
          const href = `${fullLink}&source=aiCourse`;
          const blockTag = `<span class="course-block">
            <div class='course-mask' data-href="${href}"></div>
            <img src="${coverMobile}" alt="课程封面" />
            <div class="course-info">
              <div class="course-name">${name}</div>
              <div class="course-time">课时：${time}</div>
              <div class="course-price"><span style="display: ${
                sellPrice ? 'inline-block' : 'none'
              }">￥</span>${sellPrice || '限时免费'}</div>
            </div>
          </span>`;
          const pattern1 = /\n-?\s*课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)`\s*\n*/;
          const newText = text.replace(pattern1, blockTag);
          this.newList = this.newList.map(item => {
            if (item.connectId === connectId) {
              item.answer = newText;
            }
            return item;
          });
        })
        .catch(() => {
          console.log('请求课程详情失败');
        });
    },
    // 格式化历史数据历史数据
    formatHistoryList(list) {
      const { aiCode } = this.$route.query;
      // 遍历每一项ai的回答，给出相应的格式
      for (let i = 0; i < list.length; i++) {
        if (list[i]?.roleType === 1) {
          // 主要处理ai回答，用户的问题，不需要处理
          if (list[i]?.image) {
            // 如果问题中包含图片，需要特殊处理
            const imgList = JSON.parse(list[i]?.image || '[]')?.map(item => ({ url: item })) || [];
            list[i].content = this.handleSendMsgImg(list[i]?.content, imgList);
          }
          continue;
        }
        if (this.isTableLine(list[i].content)) {
          list[i].content = this.convertMarkdownTablesToHtml(list[i].content);
        }
      }
      // 以下是处理链接卡片的,只有qhkyzs001需要处理
      if (aiCode !== 'qhkyzs001') {
        return list.map(item => {
          const { content, ...rest } = item;
          return {
            content: this.toolFilterSymbol(content),
            ...rest,
          };
        });
      }
      const temp = list.map(item => {
        const {
          clickStatus,
          connectId,
          content,
          productBaseInfoRespVO,
          createTime,
          roleType,
        } = item;
        if (roleType === 1) {
          return item;
        }
        // 处理是否展示同意
        if (
          (moment().diff(moment(createTime), 'days') <= 30 && this.checkLastSentence(content)) ||
          (moment().diff(moment(createTime), 'days') > 30 &&
            this.checkLastSentence(content) &&
            clickStatus !== 0)
        ) {
          item.footerInfo = {
            show: 1,
            isAgree: clickStatus,
            connectId,
          };
        }
        // 处理课程链接
        const pattern = /课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)`/;
        const match = content.match(pattern);
        if (match) {
          const fullLink = match[1];
          const href = `${fullLink}&source=aiCourse`;
          const pattern1 = /\n-?\s*课程链接[:|：]\s*`(https?:\/\/[^/]+\/ark\/courseDetail\?courseId=\d+)`\s*\n*/;
          if (productBaseInfoRespVO?.productId) {
            const { name, sellPrice, coverMobile, productAttributeRespVOS } = productBaseInfoRespVO;
            const time = productAttributeRespVOS.filter(
              item => item.extendAttributeNameEn === 'classPeriod',
            )[0].dataJson;
            const blockTag = `<span class="course-block">
            <div class='course-mask' data-href="${href}"></div>
            <img src="${coverMobile}" alt="课程封面" />
            <div class="course-info">
              <div class="course-name">${name}</div>
              <div class="course-time">课时：${time}</div>
              <div class="course-price"><span style="display: ${
                sellPrice ? 'inline-block' : 'none'
              }">￥</span>${sellPrice || '限时免费'}</div>
            </div>
          </span>`;
            item.content = content.replace(pattern1, blockTag);
          } else {
            const aTag = `<div style="color: #ff7f41; display: inline-block;" data-href="${fullLink}">点击查看课程</div>`;
            // // 替换原文本中的链接
            item.content = content.replace(pattern1, `课程链接：${aTag}`);
          }
        }
        // 处理表格数据
        return { ...item, content: this.toolFilterSymbol(item.content) };
      });
      return temp;
    },
    goLinkTool(type) {
      if (this.$root.$data.miniprogram) {
        switch (type) {
          case 1: // 择校
            wx.miniProgram.navigateTo({
              url: '/subPackages/plan/plan',
            });

            break;
          case 2: // 作文批改
            wx.miniProgram.navigateTo({
              url: '/correction/home/index',
            });
            break;
          case 3: // 背单词
            wx.miniProgram.navigateTo({
              url: '/pages/index/index',
            });
            break;
          case 4: // AI答疑
            wx.miniProgram.navigateTo({
              url: '/aiAnswer/answerHome/index',
            });
            break;
          default:
            break;
        }
      } else if (this.$root.$data.isApp) {
        switch (type) {
          case 1: // 择校
            this.$sendToApp('goWechatProject', {
              userName: 'gh_5fb96ed24012',
              path: '/subPackages/plan/plan',
            });

            break;
          case 2: // 作文批改
            this.$sendToApp('goWechatProject', {
              userName: 'gh_5fb96ed24012',
              path: '/correction/home/index',
            });
            break;
          case 3: // 背单词
            this.$sendToApp('goWechatProject', {
              userName: 'gh_5fb96ed24012',
              path: '/pages/index/index',
            });
            break;
          case 4: // AI答疑
            this.$sendToApp('goWechatProject', {
              userName: 'gh_5fb96ed24012',
              path: '/aiAnswer/answerHome/index',
            });
            break;
          default:
            break;
        }
      } else {
        switch (type) {
          case 1: // 择校
            reqSchemeUrl({
              appid: 'wxdb89cfa2bb60f779',
              path: '/subPackages/plan/plan',
              envVersion: window.location.host.includes('mobile.iqihang') ? 'release' : 'trial',
            }).then(res => {
              if (res?.code === 0) {
                this.chatUrl = res.data;
                window.location.href = res.data;
              }
            });
            break;
          case 2: // 作文批改
            reqSchemeUrl({
              appid: 'wxdb89cfa2bb60f779',
              path: '/correction/home/index',
              envVersion: window.location.host.includes('mobile.iqihang') ? 'release' : 'trial',
            }).then(res => {
              if (res?.code === 0) {
                this.chatUrl = res.data;
                window.location.href = res.data;
              }
            });
            break;
          case 3: // 背单词
            reqSchemeUrl({
              appid: 'wxdb89cfa2bb60f779',
              path: '/pages/index/index',
              envVersion: window.location.host.includes('mobile.iqihang') ? 'release' : 'trial',
            }).then(res => {
              if (res?.code === 0) {
                this.chatUrl = res.data;
                window.location.href = res.data;
              }
            });
            break;
          case 4: // AI答疑
            reqSchemeUrl({
              appid: 'wxdb89cfa2bb60f779',
              path: '/aiAnswer/answerHome/index',
              envVersion: window.location.host.includes('mobile.iqihang') ? 'release' : 'trial',
            }).then(res => {
              if (res?.code === 0) {
                this.chatUrl = res.data;
                window.location.href = res.data;
              }
            });
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}

::v-deep .van-list {
  overflow: hidden;
}
.msg_ai_tip {
  height: 36px;
  margin-top: 14px;
  color: #999;
  font-weight: 400;
  font-size: 22px;
  line-height: 36px;
  text-align: center;
}

.ai_dis_none {
  position: fixed;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.ai_box {
  position: relative;
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 100px;
  background: #f7f8fc;
}

::v-deep .commonTitle {
  left: 50%;
  width: 100%;
  max-width: 750px;
  transform: translateX(-50%);
}

.watermark {
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 0;
  width: 100%;
  max-width: 750px;
  height: 100vh;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/yt-words-mini/specializedQuestionBank/ai_chat_shuiyin.png')
    no-repeat;
  background-size: cover;
  transform: translateX(-50%);
}

.ai_box_top {
  padding-top: 0;
}

.lists_area {
  // width: 678px;
  position: relative;
  z-index: 1;
  max-height: 100%;
  padding: 0 36px 0;
  //   transform: rotateZ(180deg);
  //   overflow-y: scroll;

  .history_item {
    // width: 100%;
    // height: 100px;
    margin-top: 51px;
    // background: pink;
    overflow: hidden;

    .msg_time_box {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 40px;
      margin-bottom: 51px;

      .msg_time {
        height: 40px;
        padding-right: 14px;
        padding-left: 14px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
        font-style: normal;
        line-height: 40px;
        text-align: center;
        background: #fff;
        border-radius: 7px;
      }
    }

    .my_msg_box {
      float: right;
      width: 100%;
    }

    .my_msg {
      float: right;
      margin-bottom: 51px;
      padding: 22px 29px;
      color: #fff;
      background: #ff7f41;
      border-radius: 29px 5px 29px 29px;
    }

    .my_msg_history {
      margin-bottom: 0;
    }

    .ai_msg {
      float: left;
      padding: 22px 29px;
      color: #333;
      background: #fff;
      border-radius: 5px 29px 29px 29px;
    }

    .ai_msg_img {
      float: left;
      width: 100%;
      height: 76px;
      margin-bottom: 14px;

      img {
        display: block;
        float: left;
        width: 76px;
        height: 76px;
      }

      .ai_msg_img_name {
        float: left;
        width: 300px;
        height: 76px;
        margin-left: 14px;
        color: #666;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 76px;
      }
    }

    .msg_text {
      max-width: 620px;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 51px;
      white-space: pre-wrap;
      text-align: left;
    }

    ::v-deep .msg_text_loading_box {
      display: inline-block;
      width: 46px;
      height: 46px;
      margin-top: -1px;
      margin-left: 4px;
      vertical-align: middle;
    }

    .msg_text_loading {
      display: inline-block;
      height: 100%;
      overflow: hidden;
      line-height: 100%;
      animation: on_msg_text_loading 2s linear 0s infinite;
    }

    .stop_tip_line {
      height: 2px;
      margin-top: 24px;
      border: 1px solid #efefef;
    }

    .stop_tip_text {
      height: 36px;
      margin-top: 20px;
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-style: normal;
      line-height: 36px;
      text-align: left;
    }

    ::v-deep .course-block {
      position: relative;
      display: flex;
      width: 620px;
      margin: 22px 0;
      padding: 14px 14px 18px;
      background: linear-gradient(180deg, #fff7ea 0%, #fff 100%);
      border: 1px solid #f1d8b8;
      border-radius: 14px;

      .course-mask {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
      }

      img {
        display: block;
        width: 176px;
        height: 128px;
        border-radius: 11px;
      }

      .course-info {
        display: flex;
        flex: 1;
        flex-direction: column;
        width: 0;
        margin-left: 14px;

        .course-name {
          height: 33px;
          overflow: hidden;
          color: #333;
          font-weight: 500;
          font-size: 25px;
          font-style: normal;
          line-height: 33px;
          white-space: nowrap;
          text-align: left;
          text-overflow: ellipsis;
        }

        .course-time {
          height: 31px;
          margin: 11px 0 14px;
          overflow: hidden;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-style: normal;
          line-height: 31px;
          text-align: left;
        }

        .course-price {
          height: 40px;
          color: #ff3938;
          font-weight: 500;
          font-size: 29px;
          font-style: normal;
          text-align: left;
          vertical-align: baseline;

          span {
            color: #ff3938;
            font-weight: 500;
            font-size: 18px;
            font-style: normal;
            text-align: left;
          }
        }
      }
    }
  }

  .wecome_item {
    position: relative;
    width: 100%;
    // height: 100px;
    margin-top: 30px;
    // padding-top: 221px;
    // background: yellowgreen;

    .wecome_back {
      width: 678px;
      height: 290px;
      overflow: hidden;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/ai/ai_card.png') no-repeat;
      background-size: 100% 100% !important;

      .tool_hello {
        height: 40px;
        margin-top: 54px;
        margin-left: 197px;
        color: #ff5a12;
        font-weight: 600;
        font-size: 29px;
        font-style: normal;
        line-height: 40px;
        text-align: left;
      }

      .tool_desc {
        width: 451px;
        margin-top: 7px;
        margin-left: 197px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 36px;
        text-align: left;
      }

      // .img {
      //   height: 100%;
      //   width: 100%;
      // }
    }

    .wecome_card {
      width: 678px;
      margin-top: -69px;
      padding: 36px 29px 0;
      background: #fff;
      border-radius: 18px;

      .wecome_tip {
        width: 100%;
        height: 36px;
        margin-bottom: 18px;

        .img_wenhao {
          float: left;
          width: 22px;
          height: 22px;
          margin-top: 7px;
        }

        .tip_wen {
          float: left;
          height: 36px;
          margin-left: 7px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-style: normal;
          line-height: 36px;
          text-align: left;
        }

        .img_qiehuan {
          float: right;
          width: 29px;
          height: 29px;
          margin-top: 4px;
        }

        .tip_qiehuan {
          float: right;
          height: 36px;
          margin-left: 7px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          font-style: normal;
          line-height: 36px;
          text-align: left;
        }
      }

      .wecome_lists {
        // margin-top: 17px;

        .wecome_list {
          display: flex;
          align-items: center;
          height: 100px;

          .wecome_list_text {
            display: -webkit-box;
            flex-grow: 1;
            box-sizing: border-box;

            /* 包括padding和border在内计算元素的总高度 */
            // height: 100px;
            // height: calc(1.4em * 2);

            /* 根据你的padding和border调整高度，1em为单行文本的高度 */
            // min-height: calc(0.76em * 2);
            // max-height: calc(0.76em * 2);
            overflow: hidden;
            color: #333;
            font-weight: 400;
            font-size: 29px;
            font-style: normal;
            line-height: normal;

            /* 确保行高正常，避免影响垂直居中 */
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .wecome_list_text.wraps {
            min-height: calc(1.4em * 2);
            max-height: calc(1.4em * 2);
          }

          .wecome_btn {
            flex-shrink: 0;
            width: 116px;
            height: 43px;
            margin-left: 16px;
            //margin-top: 28.5px;
            color: #ff7f41;
            font-weight: 500;
            font-size: 22px;
            font-style: normal;
            line-height: 43px;
            text-align: center;
            background: rgba(255, 127, 65, 0.1);
            border-radius: 22px;
          }
        }

        .wecome_list_line {
          border-top: 2px solid #efefef;
        }
      }
    }
  }

  .new_item {
    width: 100%;
    height: 100px;
    margin-top: 30px;
    background: yellowgreen;
  }

  .empty_box {
    width: 100%;
    height: 260px;
    // background: white;
    background: #f7f8fc;
  }

  .empty_box_qh {
    height: 379px;
  }
}

.bottom {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 6;
  width: 100%;
  max-width: 750px;
  height: 140px;
  background: #f7f8fc;
  transform: translateX(-50%);

  .link_btn_box {
    display: flex;
    flex-wrap: nowrap;
    gap: 18px;
    width: 100%;
    height: 65px;
    margin-top: 29px;
    padding-right: 36px;
    padding-left: 36px;
    overflow-x: auto;

    .link_btn {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      height: 65px;
      padding: 0 18px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 65px;
      background: #fff;
      border: 2px solid #e8eaef;
      border-radius: 14px;

      img {
        display: block;
        width: 33px;
        height: 33px;
        margin-right: 11px;
      }
    }
  }

  .link_btn_box::-webkit-scrollbar {
    display: none;
  }

  // background: plum;
  .input {
    float: left;
    width: 591px;
    // height: 80px;
    margin-top: 29px;
    margin-left: 36px;
    overflow: hidden;
    background: #fff;
    border: 2px solid #e8eaef;
    border-radius: 40px;
  }

  .send_btn {
    float: left;
    width: 80px;
    height: 80px;
    margin-top: 32px;
    margin-left: 7px;

    .img {
      width: 100%;
      height: 100%;
    }
  }
}

.bottom_absolate {
  position: absolute;
}

.bottom_qh {
  height: 264px;
}

.bottom.whiteBg {
  background: #fff;
}

::v-deep .van-field__control {
  // color: #999;
  font-weight: 400;
  // font-size: 29px;
  font-style: normal;
}

@keyframes on_msg_text_loading {
  0% {
    width: 0;
  }

  100% {
    width: 20px;
  }
}

::v-deep .table_box {
  width: 100%;
  overflow-x: scroll;
}

::v-deep table {
  box-sizing: border-box;
  width: max-content;
  margin: 0;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
  border-collapse: collapse;
  border-spacing: 0;

  thead tr {
    //background: linear-gradient(138deg, #ff8a00, #f60);
    color: #fff;
    background: linear-gradient(270deg, #f60 0%, #ff8a00 100%);

    th {
      font-size: 28px;
      text-align: center;
    }
  }

  tbody tr:nth-child(2n) {
    background-color: #fff9f4;
  }

  tbody tr {
    td {
      padding: 16px;
      color: #333;
      font-weight: 400;
      font-size: 24px;
      vertical-align: middle;
      border: 1px solid #efefef;
    }
  }
}

::v-deep .vanField.uploadLeft {
  padding-left: 46px;
}

.upload_img {
  position: absolute;
  bottom: 110px;
  left: 0;
  z-index: 9;
  box-sizing: border-box;
  width: 100%;
}

.upload_img.active {
  height: 282px;
}

::v-deep .fileListImage {
  width: 500px;
  margin-top: 12px;

  img {
    width: 100%;
    border-radius: 18px;
  }
}

.enpty_list {
  width: 100%;
  height: 230px;
}

.more_history_item {
  padding-top: 22px;
  color: #999;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
}
</style>
